export const AIPromptType = {
    system: 'system',
    user: 'user',
};
export const AIPromptTypes = [AIPromptType.system, AIPromptType.user];
//# sourceMappingURL=types.js.map